module.exports = __webpack_public_path__ + "img/file.3ebfc375.svg";